import { isLatinoChannel } from './latino-app';

// 商店下载地址
const WEEE_APPLE_STORE_URL = 'https://apps.apple.com/app/apple-store/id921864548';
const LATINO_APPLE_STORE_URL = 'https://apps.apple.com/app/apple-store/id6739694173';

const WEEE_APP_DOWNLOAD_URL = 'https://itunes.apple.com/us/app/weee/id921864548?mt=8';
const LATINO_APP_DOWNLOAD_URL = 'https://itunes.apple.com/us/app/weee/id6739694173?mt=8';

const WEEE_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sayweee.weee';
const LATINO_GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sayweee.latino';

export const appStoreUrl = isLatinoChannel() ? LATINO_APPLE_STORE_URL : WEEE_APPLE_STORE_URL;
export const playStoreUrl = isLatinoChannel() ? LATINO_GOOGLE_PLAY_URL : WEEE_GOOGLE_PLAY_URL;

export const appDownloadUrl = isLatinoChannel() ? LATINO_APP_DOWNLOAD_URL : WEEE_APP_DOWNLOAD_URL;

// onelink下载地址
const WEEE_APP_PROTOCOL = 'sayweee://weee.app';
const LATINO_APP_PROTOCOL = 'masgusto://weee.app';

const WEEE_ONE_LINK_URL = 'https://weeeone.onelink.me/3WRB';
const LATINO_ONE_LINK_URL = 'https://masgusto.onelink.me/ha9k';

export const oneLinkUrl = isLatinoChannel() ? LATINO_ONE_LINK_URL : WEEE_ONE_LINK_URL;
export const appProtocol = isLatinoChannel() ? LATINO_APP_PROTOCOL : WEEE_APP_PROTOCOL;

/** 与 OpenAppPopupContent「打开 App」一致的 oneLink（af_web_dp / deep_link_value 使用当前页） */
export function getOpenAppPopupOneLinkUrl(deeplink?: string): string {
  if (deeplink) {
    return deeplink;
  }
  if (typeof window === 'undefined') {
    return '';
  }
  const webLink = encodeURIComponent(window.location.href);
  return `${oneLinkUrl}?af_web_dp=${webLink}&deep_link_value=${webLink}&ct=AppDownload_Popup&mt=8&af_dp=${appProtocol}&af_force_deeplink=true`;
}

export function openOpenAppPopupUrl(deeplink?: string): void {
  const url = getOpenAppPopupOneLinkUrl(deeplink);
  if (url) {
    window.open(url);
  }
}
